import { render, staticRenderFns } from "./CompactThumb.vue?vue&type=template&id=4723f064&scoped=true"
import script from "./CompactThumb.vue?vue&type=script&lang=js"
export * from "./CompactThumb.vue?vue&type=script&lang=js"
import style0 from "./CompactThumb.vue?vue&type=style&index=0&id=4723f064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723f064",
  null
  
)

export default component.exports